module.exports = __webpack_public_path__ + "img/today_sum1.b9c2dcbe.png";